import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { BehaviorSubject } from 'rxjs'
import { BomComponent, NamedBomComponent } from '../bom'
import { BomItemDetailComponent } from '../bom-item-detail/bom-item-detail.component'

@Component({
  selector: 'app-bom-item-detail-dialog',
  templateUrl: './bom-item-detail-dialog.component.html',
  styleUrls: ['./bom-item-detail-dialog.component.scss'],
  imports: [
    FormsModule,
    BomItemDetailComponent,
    MatButton,
    MatDialogClose,
    AsyncPipe,
    ElderTranslatePipe,
  ],
})
export class BomItemDetailDialogComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly bomItem$ = new BehaviorSubject<NamedBomComponent>(null)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const data = inject<NamedBomComponent>(MAT_DIALOG_DATA)
    this.bomItem$.next(data || new NamedBomComponent('', new BomComponent()))
  }
}
